
import storeInfo from '../store'
import { GroupedOrder } from '../types'
import { GroupedOrdersType } from './types'

export const getGroupedOrders = (stage: string) => (): GroupedOrder[] | undefined => {
  const { groupedOrders } = storeInfo.store.getState()
  return groupedOrders[stage as keyof GroupedOrdersType] || []
}
